import React from "react";
import { View, StyleSheet, Dimensions } from "react-native";
import { SPOTLIGHT_TARGETS } from "../../../Widgets/SpotlightTutorial/spotlightTargets";
import RegistrySetupModal from "./RegistrySetupModal";
import RegistrySetupButton from "./RegistrySetupButton";

const isMobile = Dimensions.get("window").width < 768;

const RegistryAddSuccess = ({ onAddMore, onDone }) => (
	<RegistrySetupModal
		icon="checkmark-circle"
		title="Your registry is off to a great start!"
		subtitle="Your selected items have been added to your Registry. You can always add more items later."
		targetId={SPOTLIGHT_TARGETS.REGISTRY_ADD_SUCCESS}
	>
		<View style={styles.actions}>
			<RegistrySetupButton label="Add More Items" variant="secondary" onPress={onAddMore} />
			<RegistrySetupButton label="Done" onPress={onDone} />
		</View>
	</RegistrySetupModal>
);

const styles = StyleSheet.create({
	actions: {
		flexDirection: isMobile ? "column" : "row",
		justifyContent: "center",
		gap: 12,
		paddingTop: 8,
		paddingBottom: 24,
	},
});

export default RegistryAddSuccess;
